import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';

import { ModalDialog } from '../components/ModalDialog.component';
import { _senderDelete, _sendersGet } from '../services/apiConnections.service';

export const Senders = () => {

    const [token, setToken] = useState(null);
    const [senders, setSenders] = useState([]);
    const [emptyTable, setEmptyTable] = useState(false);
    const [error, setError] = useState(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [senderToDelete, setSenderToDelete] = useState({});

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        setToken(storedToken);
    }, []);

    useEffect(() => {
        if (token && !senders.length && !emptyTable) {
            getData();
        }
    }, [token, senders, emptyTable]);

    const getData = async (search='') => {
        if (!token) return;
        let result = await _sendersGet(token, search);
        if (result.error) {
            console.log("--error:", result.error);
        } else {
            setEmptyTable(!result.senders.length);
            setSenders(result.senders);
        }
        setError(result.error);
    };

    const handleFilter = (value) => {
        getData(value);
    };

    const editFormatter = (cell, row) => {
        return (
            <Link className='tableIconBtn' to={`/senders/${row.ID}`}>
                <FontAwesomeIcon icon={solid('pencil')} />
            </Link>
        )
    };

    const deleteFormatter = (cell, row) => {
        return (
            <button
                className='tableIconBtn trashBtn'
                onClick={() => {
                    setSenderToDelete(row);
                    setShowDeleteDialog(true);
                }}>
                <FontAwesomeIcon icon={regular('trash-can')} />
            </button>
        )
    };

    const handleDeleteTemplate = async (id) => {
        await _senderDelete(token, id);
        getData();
        setShowDeleteDialog(false);
    };

    const columns = [{
        dataField: 'number',
        text: 'Name',
        sort: true
    },
    {
        dataField: 'edit',
        text: 'Edit',
        classes: 'iconColumn',
        formatter: editFormatter
    },
    {
        dataField: 'delete',
        text: 'Delete',
        classes: 'iconColumn',
        formatter: deleteFormatter
    }];

    const defaultSorted = [
        {
            dataField: 'name',
            order: 'asc'
        }
    ];

    const noData = () => {
        return <p className='emptyTableMessage'>You have no senders yet! Create it</p>
    };

    return (
        <div className='content wideContent'>
            <div>
                <div className='pageTitle'>
                    <span>Senders</span>
                </div>
                {error && <p className='msgBlock errorMsg'>{error}</p>}
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='myTable'>
                            <div className='tableHeader tableHeaderInline'>
                                <div className='filterCol'>
                                    <input
                                        name='senderFilter'
                                        className='searchInput'
                                        placeholder='Search...'
                                        onChange={(event) => handleFilter(event.target.value)} />
                                </div>
                                <Link className='mainBtn btn' to={'/create-sender'}>Create Sender</Link>
                            </div>
                            <BootstrapTable
                                keyField='ID'
                                data={senders}
                                columns={columns}
                                wrapperClasses='table-responsive'
                                bordered={false}
                                defaultSorted={defaultSorted}
                                pagination={paginationFactory()}
                                noDataIndication={noData} />
                        </div>
                    </div>
                </div>
                <ModalDialog
                    show={showDeleteDialog}
                    onHide={() => setShowDeleteDialog(false)}
                    onAccept={async () => handleDeleteTemplate(senderToDelete.ID)}
                    title={`Delete Sender ${senderToDelete.number}`}
                    acceptBtnText="Delete">
                    <span>{`Are you sure you want to delete Sender '${senderToDelete.number}'?`}</span>
                </ModalDialog>
            </div>
        </div>
    );
}